import { Component, OnInit, Input } from '@angular/core';

import { FooterComponent } from '../../footer/footer.component';

@Component({
  selector: 'usc-store-footer',
  templateUrl: './usc-footer.component.html',
  styleUrls: ['./usc-footer.component.css']
})
export class UscFooterComponent implements FooterComponent, OnInit {
  @Input() data: any;

  constructor() { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-footer/usc-footer.component.ts